import React, { lazy, Suspense } from 'react';
import { compose } from 'redux';
import { useTranslation } from 'react-i18next';
import WidgetBox, { Props as WidgetBoxProps } from '../_partials/WidgetBox';
import { default as Custom, Props } from './Custom';
import reduxConnectContainer from './Custom.container';
import ChunkLoadingPopover from '../_partials/ChunkLoadingPopover';

const Edit = lazy(() => import(/* webpackChunkName: "owner" */ './Edit'));

const enhance = compose(reduxConnectContainer);
const CustomBox: React.FC<Props & WidgetBoxProps> = props => {
  const {
    title,
    moduleId,
    widgetMoveUp,
    widgetRemove,
    widgetMoveDown,
    isCurrentUserCoreMember,
    section,
    zone,
  } = props;
  const { t } = useTranslation();

  const renderEditMenu = closeMenu => {
    return (
      <Suspense fallback={<ChunkLoadingPopover />}>
        <Edit moduleId={moduleId} onRequestClose={closeMenu} />
      </Suspense>
    );
  };

  return (
    <WidgetBox
      section={section}
      zone={zone}
      moduleId={moduleId}
      header={title || t('widgets.custombox.header')}
      autoShowWidgetConfig={true}
      widgetMenuRenderer={closeMenu => renderEditMenu(closeMenu)}
      widgetMoveUp={widgetMoveUp}
      widgetMoveDown={widgetMoveDown}
      widgetRemove={widgetRemove}
      editControlsTooltipContent={
        !isCurrentUserCoreMember && t('widgets.custombox.edit.tooltip')
      }
    >
      <Custom {...props} />
    </WidgetBox>
  );
};

CustomBox.displayName = 'CustomBox';

export default enhance(CustomBox);
